import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { FiInfiniteScrollDataSource } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { ObjectTypes, SideListOptionType } from '@fi-shared/types';
import { FiChecklist2Service } from '@fi-shared/checklist/fi-checklist2.service';
import { IChecklist2Parameter, IChecklistV2ForList } from '@fi-shared/checklist/checklist-v2';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { FiChecklistActionsHelperService } from '@fi-shared/checklist/fi-checklist-actions-helper.service';
import { FiChecklist2SyncService } from '@fi-shared/checklist/fi-checklist2-sync.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-system-notifications-checklists2',
    templateUrl: './checklists2.component.html',
    styleUrl: './checklists2.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-system-notifications-checklists2' },
    standalone: false,
})
export class SystemNotificationsChecklists2Component
    extends FiInfiniteScrollDataSource<IChecklistV2ForList>
    implements OnInit
{
    defaultSortColumnName = 'DueDateTime';
    defaultSortDirection = false;
    itemsListType = FiItemsListType.SystemNotificationsChecklists2;
    objectType = ObjectTypes.Checklist2;
    actions: IItemsListAction2[];

    constructor(
        injector: Injector,
        private fiChecklist2Service: FiChecklist2Service,
        private fiChecklistActionsHelperService: FiChecklistActionsHelperService,
        private fiChecklist2SyncService: FiChecklist2SyncService,
        private userDataService: FiUserDataService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.reloadData();
        this.actions = this.getChecklistListActions();

        this.fiChecklist2SyncService.notCompletedChecklistsV2Count$.subscribe(() => {
            this.reloadData();
        });
    }

    getListData(): Promise<IChecklistV2ForList[]> {
        const parameter: IChecklist2Parameter = {
            FilterType: SideListOptionType.CurrentNotCompleted,
            FetchParams: {
                FetchItems: true,
            },
        };
        return new Promise<IChecklistV2ForList[]>((resolve, reject) => {
            this.fiChecklist2Service.getChecklistsListData(parameter).then((result) => {
                resolve(result.Items);
            }, reject);
        });
    }

    private getChecklistListActions(): IItemsListAction2<IChecklistV2ForList>[] {
        const actions = this.fiChecklistActionsHelperService.getChecklistListActions({
            auditMode: false,
            templateMode: false,
            cdr: this.cdr,
            removeDataFn: (item) => this.removeData([item]),
        });
        return actions;
    }
}
